import React from 'react';
import { number } from 'prop-types';
import SiteSquiggle from 'constants/logos/SiteSquiggle';
import styles from './styles';

function BylineImagePlaceholder({ size }) {
  return (
    <div className="BylineImagePlaceholder" style={{ fontSize: size }}>
      <SiteSquiggle />
      <style jsx>{styles}</style>
    </div>
  );
}

BylineImagePlaceholder.defaultProps = {
  size: 20
};

BylineImagePlaceholder.propTypes = {
  size: number
};

export default BylineImagePlaceholder;
